export default "__VITE_ASSET__D32vpc74__"